<template>
	<div class="sch-times sch-times_selector">
		<div class="sch-timesList" v-if="typeof times !== 'undefined' && Object.keys(times).length > 0">
			<div v-if="!$store.state.api.loading && timesOpened.length === 0">
				<template v-if="workers_id === '0'">
					Выбор любого сотрудника на данный день не доступен в связи с занятостью экспертов. Выберите
					конкретного сотрудника или другую дату
				</template>
				<template v-else>
					У эксперта полная запись, по вопросам свяжитесь по телефону с администратором
				</template>
			</div>
			<div
				v-else
				class="sch-timesItem"
				v-for="item in timesOpened"
				:key="item.timestamp"
				:class="getClass(item)"
				@click="select(item)"
			>
				{{ item.time_format }}
			</div>
		</div>
		<div v-else>{{ $store.state.api.loading ? 'Загрузка...' : 'Сеансы не найдены' }}</div>
	</div>
</template>

<script>
import helper from '@/plugins/helper.js';
import _ from 'lodash';

export default {
	props: ['items', 'workers_id', 'date', 'time'],
	computed: {
		times() {
			let times = {};
			_.each(this.items, dates => {
				_.each(dates, items => {
					_.each(items, item => {
						if (typeof times[item.date] === 'undefined') times[item.date] = [];
						times[item.date].push(item); //[item.time] = item;
					});
				});
			});

			if (this.workers_id === '0') {
				_.each(times, (items, date) => {
					times[date] = _.uniqBy(items, 'timestamp');
				});
				return _.orderBy(times[helper.dateFormat(this.date)], 'timestamp');
			} else {
				if (typeof this.items[this.workers_id] !== 'undefined') {
					return this.items[this.workers_id][helper.dateFormat(this.date)];
				}
			}

			return [];
		},
		timesOpened() {
			return this.times.filter(item => item.full !== '1');
		},
	},
	methods: {
		select(item) {
			if (item.full !== '1') this.$emit('input', item.timestamp);
		},
		getClass(item) {
			let list = [];
			if (this.time === item.timestamp) list.push('sch-timesItem_active');
			if (item.full === '1') list.push('sch-timesItem_closed');

			return list;
		},
	},
};
</script>
